import React from "react";

function OnlineDetails({
  empDetails,
  userDetails,
  clickReset,
  clickView,
  clickDelete,
}) {
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Coordinator Details
      </h6>
      <p className="mb-1">
        <strong>Name:</strong> {empDetails?.firstName} {empDetails?.middleName}{" "}
        {empDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>Location:</strong> {userDetails.location?.name}
      </p>
      <p className="mb-1">
        <strong>Status:</strong> {empDetails?.status}
      </p>

      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn text-white flex-grow-1 me-2"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickView()}
        >
          View
        </button>
      </div>
    </div>
  );
}

export default OnlineDetails;
